import React from 'react';

const ReservationInfo = ({ reservation }) => {
  if (!reservation) {
    return (
      <div className="text-center py-8 text-gray-500">
        <svg className="h-12 w-12 mx-auto mb-3 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1} 
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
          />
        </svg>
        <p className="text-sm">No reservation data available</p>
      </div>
    );
  }

  return (
    <div className="mb-4 p-4 bg-purple-50 border border-purple-200 rounded-lg">
      <div className="text-sm space-y-3">
        <div className="space-y-2">
          <div>
            <span className="font-medium text-purple-700">Guest:</span>
            <span className="ml-2 text-purple-900">{reservation.guest_name || 'Unknown Guest'}</span>
          </div>
          
          {/* Phone Contact */}
          {(reservation.mobile_phone || reservation.phone || reservation.guest_phone) ? (
            <div className="flex items-center">
              <svg className="h-4 w-4 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <a 
                href={`tel:${reservation.mobile_phone || reservation.phone || reservation.guest_phone}`} 
                className="text-blue-600 hover:text-blue-800 hover:underline"
              >
                {reservation.mobile_phone || reservation.phone || reservation.guest_phone}
              </a>
            </div>
          ) : (
            <div className="flex items-center text-gray-500">
              <svg className="h-4 w-4 mr-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span className="text-sm">No phone number available</span>
            </div>
          )}
          
          {/* Email Contact */}
          {(reservation.email || reservation.guest_email) ? (
            <div className="flex items-center">
              <svg className="h-4 w-4 mr-2 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <a 
                href={`mailto:${reservation.email || reservation.guest_email}`} 
                className="text-blue-600 hover:text-blue-800 hover:underline"
              >
                {reservation.email || reservation.guest_email}
              </a>
            </div>
          ) : (
            <div className="flex items-center text-gray-500">
              <svg className="h-4 w-4 mr-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span className="text-sm">No email address available</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReservationInfo;